import { ActionText } from "./EventTitleWrapper";

import { ActionType } from "@/queries";

const SIMPLE_ACTION_LABELS: Partial<Record<ActionType, string>> = {
  [ActionType.UPDATE]: "Updated",
  [ActionType.MOVE]: "Moved",
  [ActionType.CUSTOM]: "Custom",
};

interface SimpleEventTitleProps {
  actionType: ActionType;
}

const SimpleEventTitle = ({ actionType }: SimpleEventTitleProps) => (
  <ActionText>{SIMPLE_ACTION_LABELS[actionType] ?? actionType}</ActionText>
);

export default SimpleEventTitle;
